import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Globe,
  Smartphone,
  Code2,
  Gamepad2,
  ChevronDown,
  ArrowRight
} from "lucide-react";

import logo from "../assets/logo.png";
import "./Navbar.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const goToSection = (sectionId) => {
    navigate("/");

    setTimeout(() => {
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 150);
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-container">

        {/* LOGO */}
        <Link to="/" className="navbar-left">
          <img
            src={logo}
            alt="Shirdhankar Technologies Logo"
          />

          <span>
            Shirdhankar <strong>Technologies</strong>
          </span>
        </Link>


        {/* NAVIGATION */}
        <div className="navbar-right">

          <Link to="/" className="navbar-link">
            Home
          </Link>


          <button
            type="button"
            className="navbar-link navbar-link-button"
            onClick={() => goToSection("about")}
          >
            About
          </button>


          {/* =========================
              SERVICES DROPDOWN
          ========================= */}

          <div className="services-dropdown">

            <div className="services-nav-trigger">

              <Link
                to="/services"
                className="navbar-link services-main-link"
              >
                Services
              </Link>

              <ChevronDown
                size={16}
                className="services-chevron"
              />

            </div>


            <div className="services-dropdown-menu">

              {/* WEB DEVELOPMENT */}

              <Link
                to="/services/web-development"
                className="dropdown-service"
              >
                <div className="dropdown-icon">
                  <Globe size={21} />
                </div>

                <div>
                  <strong>Web Development</strong>
                  <span>Modern websites & web applications</span>
                </div>
              </Link>


              {/* MOBILE DEVELOPMENT */}

              <Link
                to="/services/mobile-app-development"
                className="dropdown-service"
              >
                <div className="dropdown-icon">
                  <Smartphone size={21} />
                </div>

                <div>
                  <strong>Mobile App Development</strong>
                  <span>Android & cross-platform applications</span>
                </div>
              </Link>


              {/* SOFTWARE */}

              <Link
                to="/services/software-development"
                className="dropdown-service"
              >
                <div className="dropdown-icon">
                  <Code2 size={21} />
                </div>

                <div>
                  <strong>Software Development</strong>
                  <span>Custom software & SaaS solutions</span>
                </div>
              </Link>


              {/* GAME DEVELOPMENT */}

              <Link
                to="/services/game-development"
                className="dropdown-service"
              >
                <div className="dropdown-icon">
                  <Gamepad2 size={21} />
                </div>

                <div>
                  <strong>Game Development</strong>
                  <span>Unity games & interactive experiences</span>
                </div>
              </Link>


              {/* VIEW ALL */}

              <Link
                to="/services"
                className="dropdown-view-all"
              >
                View All Services

                <ArrowRight size={17} />
              </Link>

            </div>

          </div>


          <button
            type="button"
            className="navbar-link navbar-link-button"
            onClick={() => goToSection("contact")}
          >
            Contact
          </button>


          <button
            type="button"
            className="quote-btn"
            onClick={() => goToSection("contact")}
          >
            Get a Quote
          </button>

        </div>

      </div>
    </nav>
  );
}

export default Navbar;